import React, {memo} from 'react';
import type {FieldProps} from 'formik';
import {FastField} from 'formik';
import {FormControl, FormLabel, FormErrorMessage, Select} from '@tempo/core';
import {useTranslation} from '@app/hooks/useTranslation';

const IdentityField: React.FC = () => {
	const t = useTranslation();
	return (
		<FastField name="sex">
			{({form, field}: FieldProps) => (
				<FormControl
					isInvalid={Boolean(Boolean(form.errors.sex) && form.touched.sex)}
				>
					<FormLabel htmlFor="sex">{t('common.label_identity')}</FormLabel>
					<Select
						{...field}
						data-testid="sex-field"
						id="sex"
						name="sex"
						placeholder={t('common.label_identity')}
					>
						<option value="F">{t('common.genderoption_text_female')}</option>
						<option value="M">{t('common.genderoption_text_male')}</option>
						<option value="NonBinary">
							{t('common.genderoption_text_nonbinary')}
						</option>
					</Select>
					<FormErrorMessage data-testid="field-error-message">
						{form.errors.sex as string}
					</FormErrorMessage>
				</FormControl>
			)}
		</FastField>
	);
};

export default memo(IdentityField);
